import React from 'react';

const LINES = [
  'M76 437.6 C 180 430, 300 391.9, 436 336',
  'M96 346.1 C 190 341.1, 290 297.9, 416 249.6',
  'M84 257.3 C 170 247.1, 260 214.1, 388 163.3',
  'M120 170.9 C 220 158.2, 330 110, 438 74.4',
];

/** Приглушённые линии на плитке — фиксированные, как в фавиконке. */
const ON_TILE = ['#3B4C49', '#4A6862', '#4E8B7B', '#12B886'];
/** Без плитки нижние линии берут цвет текста: знак живёт и в светлой, и в тёмной теме. */
const OPACITY = [0.28, 0.42, 0.6, 1];

interface LogoMarkProps {
  size?: number;
  /** Тёмная плитка вокруг знака — как в фавиконке и на иконке приложения. */
  withTile?: boolean;
}

/**
 * Знак SkillScape: четыре линии рельефа, верхняя — акцентная. Инлайном, а не
 * файлом: знак меняет размер вместе с сайдбаром, и ради 500 байт не нужен
 * отдельный запрос.
 */
export const LogoMark: React.FC<LogoMarkProps> = ({ size = 28, withTile = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    role="img"
    aria-label="SkillScape"
    style={{ display: 'block' }}
  >
    {withTile && <rect width="512" height="512" rx="112" fill="#1A1B1E" />}
    <g fill="none" strokeWidth={withTile ? 26 : 34} strokeLinecap="round">
      {LINES.map((d, i) => (
        <path
          key={d}
          d={d}
          stroke={withTile ? ON_TILE[i] : i === LINES.length - 1 ? '#12B886' : 'currentColor'}
          opacity={withTile ? 1 : OPACITY[i]}
        />
      ))}
    </g>
  </svg>
);
